/**
 * @desc 查询水泥生产月计划
 */

import * as defs from '../../baseClass';
import { defHttp } from 'hailuo-http';
export interface Params {}

export function request(
  data: defs.IdRequest,
): Promise<defs.StandardReturn<defs.PlanMonthCementProductResponse>> {
  return defHttp.post({
    url: '/wap/plan/month/queryPlanCementProduct',
    data,
  });
}

export function mock(
  data: defs.IdRequest,
): Promise<defs.StandardReturn<defs.PlanMonthCementProductResponse>> {
  return defHttp.post({
    url: '/mock/wap/plan/month/queryPlanCementProduct',
    data,
  });
}
